module.exports = __webpack_public_path__ + "static/img/shui3.d298ed0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/shui3.jpg
// module id = BjyR
// module chunks = 0